// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Components
import { AllApplications, Overview } from './components';

const AdminDashboard = () => {
  const [view, setView] = useState('all-equipment');
  const [overviewData, setOverviewData] = useState({});
  const [loading, setLoading] = useState(true);
  const year = 'total';

  const getTitle = () => {
    switch (view) {
      case 'overview':
        return 'FIP Overview';
      case 'all-equipment':
      default:
        return 'All Equipment';
    }
  };

  const getCurrentView = () => {
    switch (view) {
      case 'overview':
        return (
          <Overview
            overviewData={overviewData}
            yearToView={year}
          />
        );
      case 'all-equipment':
      default:
        return <AllApplications />;
    }
  };

  const handleChangeView = (view) => setView(view);

  // Get overview data in background, this should only run once.
  useEffect(() => {
    setLoading(true);

    axios({
      method: 'post',
      url: `${window.wlPipConfig.ajaxUrl}?action=wl_fip_admin_get_overview`
    })
      .then(({ data: { success, data } }) => {
        if (success) {
          setOverviewData(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className="grid">
        <div className="grid__col-xs-12 grid__col-lg-6">
          <h1 className="u--color-teal u--margin-top-0">{getTitle()}</h1>
        </div>
        <div className="grid__col-xs-12 grid__col-lg-6 u--text-align-right-lg-min">
          <button
            className={`u--margin-bottom-10 btn module-hover-root ${
              view === 'all-projects' ? 'btn--gray-darkest' : 'btn--outline'
            }`}
            type="button"
            onClick={() => handleChangeView('all-projects')}
          >
            <span className="btn__content">
              <span className="btn__text">All Equipment</span>
            </span>
          </button>
          <button
            className={`u--margin-left-10 u--margin-bottom-10 btn module-hover-root ${
              view === 'overview' ? 'btn--gray-darkest' : 'btn--outline'
            }`}
            type="button"
            disabled={loading === true}
            onClick={() => handleChangeView('overview')}
          >
            <span className="btn__content">
              <span className="btn__text">FIP Overview</span>
            </span>
          </button>
        </div>
      </div>
      {getCurrentView()}
    </>
  );
};

export default AdminDashboard;
